import "../assets/scss/styles.scss";

//import "./modules/Cursor";
import "./modules/Hero";
import "./modules/Portfolio";
